import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { MorpheusReduxFormFields, Form, StatusIcon } from '@adc/ui-morpheus'
import { eventHelpContent } from '../../constants/tooltips'

const { DropdownField } = MorpheusReduxFormFields

const EventsBulkUpdateForm = ({ handleSubmit, onSubmit }) => {
  return (
    <Form padded={false} onSubmit={handleSubmit(onSubmit)} noValidate>
      <Form.Content>
        <Form.Column colSize='full'>
          <Form.Section title='Event Attributes'>
            <Field
              name='webLiveStatus'
              label='Web Live Status'
              elmId='web_live_status'
              options={[
                {
                  value: true,
                  text: (
                    <span>
                      <StatusIcon active /> Active
                    </span>
                  ),
                },
                {
                  value: false,
                  text: (
                    <span>
                      <StatusIcon active={false} /> Inactive
                    </span>
                  ),
                },
              ]}
              helpContent={eventHelpContent.WEB_LIVE_STATUS}
              component={DropdownField}
            />
          </Form.Section>
        </Form.Column>
      </Form.Content>
    </Form>
  )
}

EventsBulkUpdateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default EventsBulkUpdateForm
